import { createContext, useContext } from "react";
import { TabsProps } from "./Tabs";

type TabContextType = TabsProps;

export const TabContext = createContext<TabContextType | undefined>(undefined);

export const useTabContext = () => {
  const tabs = useContext(TabContext);
  if (tabs === undefined) {
    return {} as TabContextType;
  }
  return tabs;
};
